import { createSelector } from '@ngrx/store';
import { selectVistaUsuario, VistaUsuarioState } from '../../vista-usuario/vista-usuario.state';
import { EntityEtapasEmpresaAdapter, EntityEtapasEmpresaState } from './entity-etapas-empresa.state';

const { selectEntities, selectAll } = EntityEtapasEmpresaAdapter.getSelectors();

export const getError = (state: EntityEtapasEmpresaState): any => state.error;

export const getIsLoading = (state: EntityEtapasEmpresaState): boolean =>
  state.isLoading;

export const selectEntityEtapasEmpresaState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.etapasEmpresa
);

export const selectAllEntityEtapasEmpresa = createSelector(selectEntityEtapasEmpresaState, selectAll);
export const selectEntityEtapasEmpresaEntities = createSelector(
  selectEntityEtapasEmpresaState,
  selectEntities
);

export const selectEntityEtapasEmpresaError = createSelector(
  selectEntityEtapasEmpresaState,
  getError
);

export const selectEntityEtapasEmpresaIsLoading = createSelector(
  selectEntityEtapasEmpresaState,
  getIsLoading
);

export const selectEntityEtapasEmpresaAddedSuccess = createSelector(
  selectEntityEtapasEmpresaState,
  (state) => state.hasAddedSuccess
);
